module.exports = __webpack_public_path__ + "static/img/ditu.4c2d1da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xf/ditu.png
// module id = tiig
// module chunks = 1